module.exports = __webpack_public_path__ + "static/media/DReservation.40d540ab.png";